import { render, staticRenderFns } from "./EtapaOpcao.vue?vue&type=template&id=3ea63dda&scoped=true"
import script from "./EtapaOpcao.vue?vue&type=script&lang=js"
export * from "./EtapaOpcao.vue?vue&type=script&lang=js"
import style0 from "./EtapaOpcao.vue?vue&type=style&index=0&id=3ea63dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea63dda",
  null
  
)

export default component.exports